module.exports = __webpack_public_path__ + "static/media/profile-invite-ppl.94d73c58.png";